export function findChildrenComponent(el,componentName) {
  return el?.querySelector(`[${componentName}]`)?.components[componentName];
}

export function findChildrenComponentWithRetry(el,componentName,maxAttempts = 30,intervalMs = 1000) {
  return new Promise((resolve, reject) => {
    let attempts = 0;

    const checkElement = async () => {
      const element = el?.querySelector(`[${componentName}]`)?.components[componentName];
      attempts++;

      if (element) {
        resolve(element);
      } else if (attempts < maxAttempts) {
        setTimeout(checkElement, intervalMs);
      } else {
        reject(new Error(`Element with id "${id}" not found after ${maxAttempts} attempts.`));
      }
    };

    checkElement();
  });
}
